import React from "react";

const RecentTransactions = () => {
  return (
    <div className="dashboard-card">
      <div className="card-header">
        <h3 className="card-title">Recent Transactions</h3>
      </div>

      <div className="card-empty">
        No transactions available.
      </div>
    </div>
  );
};

export default RecentTransactions;